import React from 'react';

import { styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Button from 'components/Button';
import ArrowLeft from 'components/SvgComponents/icons/ArrowLeft';
import globalMessages from 'translations/messages/global-messages';

const Div_Wrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& .login-back-button': {
    position: 'absolute',
    top: theme.spacing(4),
    left: theme.spacing(4),
  },
}));

const LoginContainerWithBackButton = ({ className, children, onBackButtonClick }) => {
  const intl = useIntl();
  return (
    <Div_Wrapper className={className}>
      <Button
        className="login-back-button"
        variant="text"
        size="large"
        startIcon={<ArrowLeft />}
        onClick={onBackButtonClick}
      >
        {intl.formatMessage(globalMessages.back)}
      </Button>
      {children}
    </Div_Wrapper>
  );
};

LoginContainerWithBackButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
};

export default LoginContainerWithBackButton;
